export enum SocialMediaPlatform {
    LINKEDIN = 'linkedin',
    FACEBOOK = 'facebook',
    GOOGLE = 'google',
    INSTAGRAM = 'instagram'
  }